export class RequestsCountDto {
    pendingMMD: number = 0;
    pendingApproval: number = 0;
    completed: number = 0;
    rejected: number = 0;
    draft: number = 0;
    cancelled: number = 0;
    all: number = 0;
    pendingSME: number = 0;
}